export default __webpack_public_path__ + "static/media/download-appstore-badge-fr.1e7e86f2.svg";